import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import RoutePath from 'App/RoutePath';
import { PractitionerCardList } from 'Book/shared';

export default () => {
  const { t } = useTranslation('book', { keyPrefix: 'book' });

  return (
    <section className="practitioners" data-testid="practitioners">
      <h3>{t('practitioners.title')}</h3>
      <p className="view-all">
        <Link
          to={RoutePath.BookPractitioners}
          data-cy="view-all-practitioners-link"
        >
          {t('practitioners.cta')}
        </Link>
      </p>
      <PractitionerCardList
        limit={4}
        trackingEvent="book-practitioner-card-selected"
        featured={true}
      />
    </section>
  );
};
